export type ChatHistory = {
	_id?: string;
	query: string;
	answer: string;
	createdAt?: Date;
};

export interface AIChatSession {
	userId: string;
	organizationId: string;
	createdAt: Date;
	chatHistory: ChatHistory[];
}

export enum ChatAIStatus {
	NOT_AVAILABLE = "NOT_AVAILABLE",
	PROCESSING = "PROCESSING",
	COMPLETED = "COMPLETED",
	FAILED = "FAILED",
}
